const OPERATION_ERRORS = {
  addMedia: {
    operationMessage: 'upload the file.',
  },
  getUploadUrl: {
    operationMessage: 'upload the file.',
  },
};
export default OPERATION_ERRORS;
